import { Inject, Injectable } from '@angular/core';
import {
  Stripe,
  loadStripe,
  StripeElements,
  StripePaymentElement,
} from '@stripe/stripe-js';
import {
  CREZCO_DONATION_APP_CONFIG,
  CrezcoDonationAppRuntimeConfig,
} from 'src/app/app.config';

@Injectable({ providedIn: 'root' })
export class StripeElementsService {
  private stripePromise: Promise<Stripe | null>;
  private elements: StripeElements | null = null;
  private paymentElement: StripePaymentElement | null = null;

  constructor(
    @Inject(CREZCO_DONATION_APP_CONFIG)
    private config: CrezcoDonationAppRuntimeConfig
  ) {
    if (!this.config.stripePublicKey) {
      throw new Error('Stripe public key is missing in config');
    }
    this.stripePromise = loadStripe(this.config.stripePublicKey);
  }

  async mountPaymentElement(
    domElement: HTMLElement,
    clientSecret: string
  ): Promise<StripePaymentElement | null> {
    const stripe = await this.stripePromise;
    if (!stripe) return null;

    this.reset();

    this.elements = stripe.elements({ clientSecret });
    this.paymentElement = this.elements.create('payment');
    this.paymentElement.mount(domElement);

    return this.paymentElement;
  }

  async confirmPayment(): Promise<any> {
    const stripe = await this.stripePromise;
    console.log({ elements: this.elements });
    if (!stripe || !this.elements)
      throw new Error('Stripe o Elements no están disponibles');

    return await stripe.confirmPayment({
      elements: this.elements,
      redirect: 'if_required', // si no quieres redirección forzada
      confirmParams: {},
    });
  }

  async confirmSetup() {
    const stripe = await this.stripePromise;
    console.log({ theElem: this.elements });
    if (!stripe || !this.elements)
      throw new Error('Stripe o Elements no están disponibles');

    return stripe.confirmSetup({
      elements: this.elements,
      redirect: 'if_required', // si no quieres redirección forzada
      confirmParams: {},
    });
  }

  async confirmInvoicePayment(clientSecret: string) {
    const stripe = await this.stripePromise;
    if (!stripe) throw new Error('Stripe no inicializado');

    // Evita redirecciones si no son necesarias
    return stripe.confirmCardPayment(clientSecret, {
      // sin elements: ya hay default_payment_method en el PI del invoice
    });
  }

  reset(): void {
    try {
      this.paymentElement?.unmount();
    } catch (error: any) {
      const message = String(error?.message ?? '');

      if (!message.includes('already been destroyed')) {
        throw error;
      }
    } finally {
      this.paymentElement = null;
      this.elements = null;
    }
  }
}
